module.exports = __webpack_public_path__ + "95528f4d9a72f65efb28980600ce9857.png";


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/content/images/imagepersonnages.png
// module id = 467
// module chunks = 0